export default __webpack_public_path__ + "static/media/dealsOver599.936d6a6f.png";